import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapFrostSensorTempLimitExecutionTargets = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.FROST_SENSOR_TEMP_LIMIT,
      iprId: update.assetId,
      payload: {
        restrictTemperatureLimit: update.value,
      },
    },
  ];
};
